import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { useRootStore } from 'stores/RootStore'
import { DesignMenu } from './DesignMenu'
import { MovePanel } from './MovePanel'
import { DesignMenuContainerProps } from './Types'

export const DesignMenuContainer = observer(
  ({ id, onAction, dismiss, onMoveAction, onMoveSuccess, onRename, ...rest }: DesignMenuContainerProps) => {
    const [showMove, setShowMove] = useState(false)
    const { files } = useRootStore()
    const file = files.get(id)

    useEffect(() => {
      files.fetch(id)
    }, [id, files])

    if (!file) {
      return null
    }

    if (showMove) {
      return <MovePanel file={file} dismiss={dismiss} onSuccess={onMoveSuccess} />
    }

    return (
      <DesignMenu
        {...rest}
        file={file}
        onAction={(action) => {
          if (action === 'rename') {
            onRename?.()
          }
          if (action === 'move') {
            setShowMove(true)
            onMoveAction?.(() => setShowMove(false))
            return
          }
          onAction?.(action)
        }}
      />
    )
  },
)
